import type { FC } from 'react';
import React from 'react';
import { useFormikContext } from "formik";
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { WizardSummaryLayout } from '../../../components/wizard/wizard-summary-layout';

interface SummaryProps {
    onBack: (event: any) => void | undefined;
}

const ButtonSummary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div>
        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.description)}:</h2>
        <div className="flex">
            <div className="w-1/3">
                <h4 className="p-1 text-xs text-gray-600">
                    {translate.byKey(TranslationKeys.type)}:
                </h4>
            </div>
            <div className="w-2/3 mt-1">
                <div className="text-sm text-black">
                    {values.type}
                </div>
            </div>
        </div>

        <div className="flex pb-3">
            <div className="w-1/3">
                <h4 className="p-1 text-xs text-gray-600">
                    {translate.byKey(TranslationKeys.buttonText)}:
                </h4>
            </div>
            <div className="w-2/3 mt-1">
                <div className="text-sm text-black">
                    {values.buttonText}
                </div>
            </div>
        </div>
        </div>
    </WizardSummaryLayout>
}

export default ButtonSummary;
